export const OPEN_TOAST = "OPEN_TOAST";
export const CLOSE_TOAST = "CLOSE_TOAST";

let toastTimer = 0;

export const showToast = (message, status) => dispatch => {
	dispatch({
		type: OPEN_TOAST,
		message,
		status
	});
	clearTimeout(toastTimer);
	toastTimer = setTimeout(() => dispatch({ type: CLOSE_TOAST }), 3000);
};
